import Cookies from 'js-cookie'
import store from 'src/vuex/store.js'
import Router from 'vue-router'
import Vue from 'vue'

import DashboardLayout from 'src/layout/DashboardLayout.vue'
// Auth
import Login from 'src/pages/Auth/Login.vue'

// GeneralViews
import NotFound from 'src/pages/NotFoundPage.vue'
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'

// Members
import MemberLayout from 'src/pages/Members/MemberLayout.vue'
import MemberNew from 'src/pages/Members/MemberNew.vue'
import MemberEdit from 'src/pages/Members/MemberEdit.vue'

// Monthly Payments
import Monthly from 'src/pages/Monthly/Monthly.vue'
import NewCollection from 'src/pages/Monthly/NewCollection.vue'
// import EditCollection from 'src/pages/Monthly/EditCollection.vue'
import NewMonthlyPaymentRecived from '../pages/Monthly/NewMonthlyPaymentRecived.vue'
import EditMonthlyPaymentRecived from '../pages/Monthly/EditMonthlyPaymentRecived.vue'

// Settings
import Settings from 'src/pages/Settings/Settings.vue'

// Events
import Events from 'src/pages/Events/Events.vue'
import NewEvents from '../pages/Events/NewEvents.vue'
import EditEvents from '../pages/Events/EditEvents.vue'

// News
import News from 'src/pages/News/News.vue'
import NewNews from '../pages/News/NewNews.vue'
import EditNews from '../pages/News/EditNews.vue'

// Admin
import Administrators from 'src/pages/Admin/Administrators.vue'
import NewAdministrators from 'src/pages/Admin/NewAdministrators.vue'
import EditAdministrators from 'src/pages/Admin/EditAdministrators.vue'

// Promotions
import Promotions from 'src/pages/Promotions/Promotions.vue'
import NewPromotions from 'src/pages/Promotions/NewPromotions.vue'
import EditPromotions from 'src/pages/Promotions/EditPromotions.vue'

// Variables
import Variables from 'src/pages/Variables/Variables.vue'

// Banks
import Banks from 'src/pages/Banks/Banks.vue'
import NewBanks from 'src/pages/Banks/NewBanks.vue'
import EditBanks from 'src/pages/Banks/EditBanks.vue'

// Mails
import Mails from 'src/pages/Mails/Mails.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login
      }
    ]
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'members',
        name: 'Members',
        component: MemberLayout
      },
      {
        path: 'members/new',
        name: 'MemberNew',
        component: MemberNew
      },
      {
        path: 'members/edit/:id',
        name: 'MemberEdit',
        component: MemberEdit
      },
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: UserProfile
      },
      {
        path: 'events',
        name: 'Events',
        component: Events
      },
      {
        path: 'events/new',
        name: 'NewEvents',
        component: NewEvents
      },
      {
        path: 'events/edit/:id',
        name: 'EditEvents',
        component: EditEvents
      },
      {
        path: 'news',
        name: 'News',
        component: News
      },
      {
        path: 'news/new',
        name: 'NewNews',
        component: NewNews
      },
      {
        path: 'news/edit/:id',
        name: 'EditNews',
        component: EditNews
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: 'variables',
        name: 'Variables',
        component: Variables
      },
      {
        path: 'banks',
        name: 'Banks',
        component: Banks
      },
      {
        path: 'banks/new',
        name: 'NewBanks',
        component: NewBanks
      },
      {
        path: 'banks/edit/:id',
        name: 'EditBanks',
        component: EditBanks
      },
      {
        path: 'mails',
        name: 'Mails',
        component: Mails
      },
      {
        path: 'promotions',
        name: 'Promotions',
        component: Promotions
      },
      {
        path: 'promotions/new',
        name: 'NewPromotions',
        component: NewPromotions
      },
      {
        path: 'promotions/edit/:id',
        name: 'EditPromotions',
        component: EditPromotions
      },
      {
        path: 'administrators',
        name: 'Administrators',
        component: Administrators
      },
      {
        path: 'administrators/new',
        name: 'NewAdministrators',
        component: NewAdministrators
      },
      {
        path: 'administrators/edit/:id',
        name: 'EditAdministrators',
        component: EditAdministrators
      },
      {
        path: 'monthly-payments',
        name: 'Monthly',
        component: Monthly
      },
      {
        path: 'monthly-payments/new-collection',
        name: 'NewCollection',
        component: NewCollection
      },
      /*
      {
        path: 'monthly-payments/edit-collection/:id',
        name: 'EditCollection',
        component: EditCollection
      },
      */
      {
        path: 'monthly-payments/new-payment',
        name: 'NewMonthlyPaymentRecived',
        component: NewMonthlyPaymentRecived
      },
      {
        path: 'monthly-payments/edit-payment/:id',
        name: 'EditMonthlyPaymentRecived',
        component: EditMonthlyPaymentRecived
      }
    ]
  },
  { path: '*', component: NotFound }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log('accediendo')
  const accessToken = Cookies.get('access_token')

  if (accessToken) {
    if (
      to.matched.some((record) => record.meta.requiresAuth) &&
      !store.state.status &&
      !accessToken
    ) {
      alert('Please, sign in to continue')
      next('/login')
    } else if (store.state.status && accessToken) {
      console.log('logged')
      next('/admin/overview')
    } else {
      console.log('Next')
      next()
    }
  } else {
    console.log('TOKEN NOT FOUND')
    console.log(to.name)
    console.log(from.name)
    if (to.name != 'login') {
      next('/login')
    } else {
      next()
    }
  }
})

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default router
